import { render } from "./AppleSsoComp.vue?vue&type=template&id=5119e00a"
import script from "./AppleSsoComp.vue?vue&type=script&lang=js"
export * from "./AppleSsoComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__